import { Group, Stack, Text } from "@mantine/core"
import { IconQrcode } from "@tabler/icons-react"
import { Button, CopyButton } from "@tfg/ui"
import QRCode from "qrcode"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"

import { UpdateDisplaySettingButton } from "~/pages/Brand/OrganizationSettings/ProductPages/DisplaySettingsCrud/UpdateDisplaySettingButton.tsx"
import { publicAgecSearchPath } from "~/pages/Brand/Products/List/constants.ts"

interface Props {
  displaySetting: OrganizationsResponses.Organization["settings"]["displaySettings"][number]
  settings: Omit<
    OrganizationsResponses.Organization["settings"],
    "displaySettings"
  >
}
export const SearchEngineURL = ({ displaySetting, settings }: Props) => {
  const searchEngineURL = `${document.location.origin}/${publicAgecSearchPath}/${displaySetting.slug}`
  const { t } = useTranslation("organizationSettings")

  const [qrCodeImg, setQrCodeImg] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (!searchEngineURL) return

    QRCode.toDataURL(searchEngineURL, { width: 500 })
      .then((url) => {
        setQrCodeImg(url)
      })
      .catch((error) => {
        console.error("QR code generation failed:", error)
        setQrCodeImg(undefined)
      })
  }, [searchEngineURL])

  return (
    <Stack gap="var(--tfg-organism-padding-y)">
      <Group gap="var(--tfg-molecule-padding-x)">
        <Text>{t("customerInformation.searchEngine.label")}</Text>
        <CopyButton
          copyableText={searchEngineURL}
          variant="primary"
          title={t("copyButton.copy")}
        />
        <Button
          icon={<IconQrcode />}
          component="a"
          variant="secondary"
          download="qrCode.png"
          href={qrCodeImg}
        >
          {t("qrCode.download")}
        </Button>
        <UpdateDisplaySettingButton
          organizationSettingsId={settings.id}
          organizationId={14}
          displaySetting={displaySetting}
        />
      </Group>
    </Stack>
  )
}
